enum GroupType {
    NONE = "none",
    UNKNOWN = "unknown",
    PUBLIC = "public",
    PRIVATE = "private",
    ROLE_STUDENT = "role_student",
    ROLE_TEACHER = "role_teacher"
}

export default GroupType;